// extracted by mini-css-extract-plugin
export default {"notFound":"PageNotFound_notFound__ur6r6","classNotFound":"PageNotFound_classNotFound__VM6Sl","classNotFound404":"PageNotFound_classNotFound404__-oyK7"};